<template>
  <v-autocomplete
    v-bind="this.$attrs"
    label="Môn học"
    item-text="label"
    :items="filteredCourses"
    item-value="id"
    @change="onChange"
    return-object
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
  ></v-autocomplete>
  <!-- :rules="[v => !!v || 'Item is required']" -->
</template>

<script>
import { mapGetters } from 'vuex'
import { Course } from '@/plugins/api'

export default {
  data: () => ({
    courses: []
  }),
  props: {
    filters: Object,
    options: Object,
    defaultCourses: Array,
    allCourses: Array
  },
  computed: {
    ...mapGetters('app', ['department', 'roles', 'roleIdByName']),
    filteredCourses() {
      let output
      if (!this.allCourses) {
        output = this.courses
      } else {
        output = this.courses.filter(item => {
          return this.allCourses.includes(item.id)
        })
      }
      return output.map(({ title, code, ...o }) => ({
        ...o,
        title,
        code,
        label: `${title} (${code})`
      }))
    }
  },
  created() {
    if (this.defaultCourses) {
      this.courses = this.defaultCourses
    }
    this.fetchCourse()
  },
  methods: {
    async fetchCourse() {
      this.courses = await Course.fetch({
        ...this.filters,
        department: this.department.id
      })
    },
    async update(data) {
      // this.courses = await Staff.fetch({
      //   ...this.filters,
      //   department: this.department.id,
      //   role: this.roleIdByName('teacher'),
      //   code_contains: data
      // })
    },
    onChange(data) {
      console.log(data)
      this.$emit('change', data)
    }
  },
  watch: {
    filters(filters) {
      this.fetchCourse()
    }
  }
}
</script>
